/* eslint-disable @typescript-eslint/no-extraneous-class */
export class ServiceBusController {
    // TODO: ie handling authentication status...
    constructor() {}
}
